import React, { useEffect, useState } from "react";
import { Calendar } from "../../components";
import { Card, Container } from "react-bootstrap";
import { loadEventsPerWeek } from "../../api/event";
import { useSelector } from "react-redux";
import { FieldTimeOutlined } from "@ant-design/icons";
import { getAllGymMembers } from "../../api/gym";
import { toast } from "react-toastify";
import "./styles/event.css";
// import EventCalender from "../../components/admin/EventCalender";

const CalenderOfEvents = () => {
  const { user } = useSelector((state) => ({ ...state }));
  const [loading, setLoading] = useState(false);
  const [events, setEvents] = useState([]);
  const [members, setMembers] = useState([]);

  useEffect(() => {
    loadMembers();
  }, []);

  const loadMembers = async () => {
    try {
      setLoading(true);
      const res = await getAllGymMembers(user.token);
      setMembers(res.data);
      loadEvents();
    } catch (error) {
      toast.error(
        error.response
          ? error.response.data
          : "Some error occured please try later"
      );
      console.log(error);
    }
  };

  const loadEvents = async () => {
    try {
      setLoading(true);
      const events = await loadEventsPerWeek(user.token);
      setEvents(events.data);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response
          ? error.response.data
          : "Some error occured please try later"
      );
      console.log(error);
    }
  };

  const displayTime = (date) => `${date.getHours()}:${date.getMinutes()}`;
  const displayDayName = (dateString) => {
    var days = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    var d = new Date(dateString);
    var dayName = days[d.getDay()];
    return dayName;
  };

  return (
    <div className="container">
      <div className="row align-items-start admin-calender-of-events mt-5">
        <div className="col-md-6 calender-div">
          <Calendar loadEvents={loadEvents} members={members} />
        </div>
        <div className="col-md-4 events-div">
          <h3 className="event-head">Events This Week</h3>
          {loading ? (
            <h5>loading...</h5>
          ) : (
            <div className="events">
              {events.length ? (
                events.map((each, i) => (
                  <div key={i} className="each-event shadow">
                    <div className="d-flex event-details-container">
                      <div className="event-date text-center">
                        <div>
                          <h5>{`${new Date(each.date).getDate()}`}</h5>
                        </div>
                        <div>
                          <h6>{displayDayName(each.date)}</h6>
                        </div>
                      </div>
                      <div className="event-other-details">
                        <div className="event-details-header">
                          <h5>{each.title}</h5>
                          <h6>{each.location}</h6>
                        </div>
                        <div className="event-time-container">
                          <div className="event-time">
                            <h6>Start Time</h6>
                            <div className="d-flex align-items-center">
                              <FieldTimeOutlined
                                style={{ marginRight: "3px" }}
                              />
                              {displayTime(new Date(each.start))}
                            </div>
                          </div>
                          <div className="event-time">
                            <h6>End Time</h6>
                            <div className="d-flex align-items-center">
                              <FieldTimeOutlined
                                style={{ marginRight: "3px" }}
                              />
                              {displayTime(new Date(each.end))}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <h3>No Events This Week</h3>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CalenderOfEvents;
